var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5Z",
    fill: "#FDC5C5",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1638 18H46.5924V21.808H35.1638V18ZM54.2476 30.1646L56.9791 27.4343L54.2857 24.742L51.5562 27.4704C48.5656 25.0749 44.8573 23.7515 41.0251 23.7121C37.1929 23.6728 33.4583 24.9197 30.4191 27.2534L33.1238 29.9951C35.3836 28.3908 38.0854 27.526 40.8571 27.5199L40.8762 27.5218V40.8117L50.3105 50.2517C48.448 52.1221 46.072 53.3979 43.4835 53.9172C40.895 54.4366 38.2105 54.1763 35.7702 53.1692C33.3298 52.1621 31.2435 50.4535 29.7754 48.2601C28.3074 46.0666 27.5238 43.4869 27.5238 40.8479H33.2381L25.619 33.2319L18 40.8479H23.7143C23.7117 43.5861 24.3656 46.2851 25.6213 48.7187C26.8769 51.1524 28.6977 53.2498 30.9312 54.8353C33.1646 56.4208 35.7456 57.4482 38.458 57.8314C41.1704 58.2146 43.9352 57.9425 46.5207 57.0378C49.1063 56.1332 51.4373 54.6223 53.3185 52.6319C55.1997 50.6414 56.5763 48.2293 57.333 45.5976C58.0897 42.9659 58.2044 40.1912 57.6676 37.5061C57.1308 34.8209 55.9581 32.3035 54.2476 30.1646Z",
    fill: "#CF2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeft);
export default __webpack_public_path__ + "static/media/NEFT.4664fa7685192b245ec8edf7ffaf7762.svg";
export { ForwardRef as ReactComponent };